import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supportedLngs, supportedLngsObj } from "../helpers/utils";
import LanguageDisclaimer from "./../components/languageDisclaimer";
import { TRANSLATED_PATHS } from "../redux/config";
import axios from "axios";
import { API_URL } from "../redux/config";
function LanguageHandler() {
  const { lng } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(false);
  const [mlids, setMlids] = useState([]);

  useEffect(() => {
    axios.get(API_URL + "mlids/").then((res) => {
      setMlids(res.data);
    });
  }, [lng, i18n, location]);

  useEffect(() => {
    const combinedpaths = TRANSLATED_PATHS.concat(mlids);

    if (
      (i18n.language === supportedLngsObj.HINDI ||
      i18n.language === supportedLngsObj.GUJARATI ||
      i18n.language === supportedLngsObj.MARATHI) &&
      combinedpaths.indexOf(location.pathname) == -1
    ) {
      setModalOpen(true);
      return;
      // setTimeout(() => {
      //   setModalOpen(false);
      // }, 3000);
    }
  }, [lng, i18n, location]);

  useEffect(() => {
    if (lng && supportedLngs.includes(lng)) {
      i18n.changeLanguage(lng); // Change language based on URL parameter
    } else if (lng && !supportedLngs.includes(lng)) {
      i18n.changeLanguage(supportedLngsObj.ENGLISH);
    } else if (!lng) {
      i18n.changeLanguage(supportedLngsObj.ENGLISH); // Default to English if no parameter is present
    }
  }, [lng, i18n]);

  return (
    <div>
      <LanguageDisclaimer
        lng={lng}
        modalOpen={modalOpen}
        closeModal={() => {
          setModalOpen(false);
        }}
      />
      <Outlet />
    </div>
  );
}

export default LanguageHandler;
